<template>
  <div class="sort-box">
    <div
      class="sort-list"
      @click="handleSort(item, index)"
      v-for="(item, index) in localSortData"
      :key="item.key"
    >
      <div class="sort-name">{{ item.name }}</div>
      <div class="sort-icon">
        <i
          class="el-icon-caret-top"
          :class="item.value === 'up' ? 'color52C41A' : ''"
        ></i>
        <i
          class="el-icon-caret-bottom"
          :class="item.value === 'down' ? 'color52C41A' : ''"
        ></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomTabBox",
  components: {},
  props: {
    sortData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectTab: null,
      localSortData: [],
    };
  },
  mounted() {
    this.localSortData = this.sortData;
  },
  methods: {
    handleSort(item, index) {
      let params = {};
      if (!this.localSortData[index].value) {
        this.localSortData[index].value = "up";
      } else if (this.localSortData[index].value === "up") {
        this.localSortData[index].value = "down";
      } else if (this.localSortData[index].value === "down") {
        this.localSortData[index].value = "";
      }
      this.localSortData.forEach((item, index) => {
        params[item.key] = item.value;
      });
      this.$emit("sortChange", params);
    },
  },
};
</script>

<style scoped lang="scss">
.sort-box {
  display: flex;
  align-items: center;
  .sort-list {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: 0.2rem;
    .sort-name {
      font-size: 0.12rem;
      color: #434343;
      line-height: 0.2rem;
    }
    .sort-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      padding-left: 0.02rem;
      .el-icon-caret-top {
        position: relative;
        top: 0.03rem;
      }
      .el-icon-caret-bottom {
        position: relative;
        top: -0.03rem;
      }
      i {
        font-size: 0.13rem;
      }
    }
  }
}
</style>
